/* ==========================================================================
   Charliee - site-wide guards. Loaded on every page from meta-tags.liquid.

   1) QUANTITY DIRECTION
      Dawn's QuantityInput picks direction with:
          event.target.name === 'plus' ? stepUp() : stepDown()
      event.target is whatever was actually clicked. Dawn renders an <svg>
      icon inside those buttons, so a tap landing on the icon has no `name`
      attribute, the test fails, and it calls stepDown(). The plus button
      subtracts. This affects the product page quantity selector and every
      other quantity-input in the theme.

      Fixed two ways: CSS makes icons transparent to pointer events, and a
      capture-phase listener re-fires any click that still lands on a child.

   2) ADD-TO-CART SAFETY
      Add buttons that submit a product form are left entirely alone - Dawn
      handles those. We only guard against double submits, which on a slow
      connection add the same item twice.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1. quantity direction ---------- */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;
      var btn = event.target.closest('quantity-input button[name], .cab-qty button[name]');
      if (!btn) return;
      if (event.target === btn) return; // already the right target

      event.stopPropagation();
      event.preventDefault();
      btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    },
    true
  );

  /* ---------- 2. block accidental double add-to-cart ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var btn = form.querySelector('[name="add"], button[type="submit"]');
    if (!btn || btn.dataset.cabBusy === '1') return;

    btn.dataset.cabBusy = '1';
    setTimeout(function () { delete btn.dataset.cabBusy; }, 1200);
  });
})();
